'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.updateAdresa_CEF31D = updateAdresa_CEF31D;
exports.updateMapAdresa_CEF31D = updateMapAdresa_CEF31D;
exports.updateListAdresa_CEF31D = updateListAdresa_CEF31D;
exports.updateFindAdresyParams_6B6AAA = updateFindAdresyParams_6B6AAA;
exports.updateMapFindAdresyParams_6B6AAA = updateMapFindAdresyParams_6B6AAA;
exports.updateListFindAdresyParams_6B6AAA = updateListFindAdresyParams_6B6AAA;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:16:40Z                      #

// ##############################################################

function updateAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    var result = (0, _extends3.default)({}, data, {
        '@class': data['@class'] ? data['@class'] : 'AdresaVO'
    });

    return result;
}

function updateMapAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    var result = {};
    (0, _keys2.default)(data).forEach(function (key) {
        result[key] = updateAdresa_CEF31D(data[key]);
    });
    return result;
}

function updateListAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateAdresa_CEF31D);
}

function updateFindAdresyParams_6B6AAA(data) {
    if (data == null) {
        return data;
    }
    var result = (0, _extends3.default)({}, data, {
        '@class': data['@class'] ? data['@class'] : 'FindAdresyParamsVO'
    });

    return result;
}

function updateMapFindAdresyParams_6B6AAA(data) {
    if (data == null) {
        return data;
    }
    var result = {};
    (0, _keys2.default)(data).forEach(function (key) {
        result[key] = updateFindAdresyParams_6B6AAA(data[key]);
    });
    return result;
}

function updateListFindAdresyParams_6B6AAA(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateFindAdresyParams_6B6AAA);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvYXBpL2dlbi9hZHJlc3kvVXBkYXRlTWV0aG9kcy5qc3giXSwibmFtZXMiOlsidXBkYXRlQWRyZXNhX0NFRjMxRCIsInVwZGF0ZU1hcEFkcmVzYV9DRUYzMUQiLCJ1cGRhdGVMaXN0QWRyZXNhX0NFRjMxRCIsInVwZGF0ZUZpbmRBZHJlc3lQYXJhbXNfNkI2QUFBIiwidXBkYXRlTWFwRmluZEFkcmVzeVBhcmFtc182QjZBQUEiLCJ1cGRhdGVMaXN0RmluZEFkcmVzeVBhcmFtc182QjZBQUEiLCJkYXRhIiwicmVzdWx0IiwiZm9yRWFjaCIsImtleSIsIm1hcCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7UUFRZ0JBLG1CLEdBQUFBLG1CO1FBYUFDLHNCLEdBQUFBLHNCO1FBV0FDLHVCLEdBQUFBLHVCO1FBT0FDLDZCLEdBQUFBLDZCO1FBYUFDLGdDLEdBQUFBLGdDO1FBV0FDLGlDLEdBQUFBLGlDOzs7O0FBL0RoQjs7QUFFQTs7QUFFQTs7QUFFQTs7QUFFTyxTQUFTTCxtQkFBVCxDQUE2Qk0sSUFBN0IsRUFBbUM7QUFDdEMsUUFBSUEsUUFBUSxJQUFaLEVBQWtCO0FBQ2QsZUFBT0EsSUFBUDtBQUNIO0FBQ0QsUUFBSUMsb0NBQ0dELElBREg7QUFFQSxrQkFBVUEsS0FBSyxRQUFMLElBQWlCQSxLQUFLLFFBQUwsQ0FBakIsR0FBa0M7QUFGNUMsTUFBSjs7QUFNQSxXQUFPQyxNQUFQO0FBQ0g7O0FBRU0sU0FBU04sc0JBQVQsQ0FBZ0NLLElBQWhDLEVBQXNDO0FBQ3pDLFFBQUlBLFFBQVEsSUFBWixFQUFrQjtBQUNkLGVBQU9BLElBQVA7QUFDSDtBQUNELFFBQU1DLFNBQVMsRUFBZjtBQUNBLHdCQUFZRCxJQUFaLEVBQWtCRSxPQUFsQixDQUEwQixlQUFPO0FBQzdCRCxlQUFPRSxHQUFQLElBQWNULG9CQUFvQk0sS0FBS0csR0FBTCxDQUFwQixDQUFkO0FBQ0gsS0FGRDtBQUdBLFdBQU9GLE1BQVA7QUFDSDs7QUFFTSxTQUFTTCx1QkFBVCxDQUFpQ0ksSUFBakMsRUFBdUM7QUFDMUMsUUFBSUEsUUFBUSxJQUFaLEVBQWtCO0FBQ2QsZUFBT0EsSUFBUDtBQUNIO0FBQ0QsV0FBT0EsS0FBS0ksR0FBTCxDQUFTVixtQkFBVCxDQUFQO0FBQ0g7O0FBRU0sU0FBU0csNkJBQVQsQ0FBdUNHLElBQXZDLEVBQTZDO0FBQ2hELFFBQUlBLFFBQVEsSUFBWixFQUFrQjtBQUNkLGVBQU9BLElBQVA7QUFDSDtBQUNELFFBQUlDLG9DQUNHRCxJQURIO0FBRUEsa0JBQVVBLEtBQUssUUFBTCxJQUFpQkEsS0FBSyxRQUFMLENBQWpCLEdBQWtDO0FBRjVDLE1BQUo7O0FBTUEsV0FBT0MsTUFBUDtBQUNIOztBQUVNLFNBQVNILGdDQUFULENBQTBDRSxJQUExQyxFQUFnRDtBQUNuRCxRQUFJQSxRQUFRLElBQVosRUFBa0I7QUFDZCxlQUFPQSxJQUFQO0FBQ0g7QUFDRCxRQUFNQyxTQUFTLEVBQWY7QUFDQSx3QkFBWUQsSUFBWixFQUFrQkUsT0FBbEIsQ0FBMEIsZUFBTztBQUM3QkQsZUFBT0UsR0FBUCxJQUFjTiw4QkFBOEJHLEtBQUtHLEdBQUwsQ0FBOUIsQ0FBZDtBQUNILEtBRkQ7QUFHQSxXQUFPRixNQUFQO0FBQ0g7O0FBRU0sU0FBU0YsaUNBQVQsQ0FBMkNDLElBQTNDLEVBQWlEO0FBQ3BELFFBQUlBLFFBQVEsSUFBWixFQUFrQjtBQUNkLGVBQU9BLElBQVA7QUFDSDtBQUNELFdBQU9BLEtBQUtJLEdBQUwsQ0FBU1AsNkJBQVQsQ0FBUDtBQUNIIiwiZmlsZSI6IlVwZGF0ZU1ldGhvZHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyAjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjI1xuXG4vLyAjICAgICAgICAgICAgIEdFTkVST1ZBTsOdIEvDk0QsIE5FTU9ESUZJS09WQVQhISEhICAgICAgICAgICAgICAjXG5cbi8vICMgICAgICAgICAgICAgICAgICAyMDI1LTAxLTA3VDIyOjE2OjQwWiAgICAgICAgICAgICAgICAgICAgICAjXG5cbi8vICMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjXG5cbmV4cG9ydCBmdW5jdGlvbiB1cGRhdGVBZHJlc2FfQ0VGMzFEKGRhdGEpIHtcbiAgICBpZiAoZGF0YSA9PSBudWxsKSB7XG4gICAgICAgIHJldHVybiBkYXRhO1xuICAgIH1cbiAgICBsZXQgcmVzdWx0ID0ge1xuICAgICAgICAuLi5kYXRhLFxuICAgICAgICAnQGNsYXNzJzogZGF0YVsnQGNsYXNzJ10gPyBkYXRhWydAY2xhc3MnXSA6ICdBZHJlc2FWTycsXG4gICAgfTtcblxuXG4gICAgcmV0dXJuIHJlc3VsdDtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHVwZGF0ZU1hcEFkcmVzYV9DRUYzMUQoZGF0YSkge1xuICAgIGlmIChkYXRhID09IG51bGwpIHtcbiAgICAgICAgcmV0dXJuIGRhdGE7XG4gICAgfVxuICAgIGNvbnN0IHJlc3VsdCA9IHt9O1xuICAgIE9iamVjdC5rZXlzKGRhdGEpLmZvckVhY2goa2V5ID0+IHtcbiAgICAgICAgcmVzdWx0W2tleV0gPSB1cGRhdGVBZHJlc2FfQ0VGMzFEKGRhdGFba2V5XSk7XG4gICAgfSk7XG4gICAgcmV0dXJuIHJlc3VsdDtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHVwZGF0ZUxpc3RBZHJlc2FfQ0VGMzFEKGRhdGEpIHtcbiAgICBpZiAoZGF0YSA9PSBudWxsKSB7XG4gICAgICAgIHJldHVybiBkYXRhO1xuICAgIH1cbiAgICByZXR1cm4gZGF0YS5tYXAodXBkYXRlQWRyZXNhX0NFRjMxRCk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiB1cGRhdGVGaW5kQWRyZXN5UGFyYW1zXzZCNkFBQShkYXRhKSB7XG4gICAgaWYgKGRhdGEgPT0gbnVsbCkge1xuICAgICAgICByZXR1cm4gZGF0YTtcbiAgICB9XG4gICAgbGV0IHJlc3VsdCA9IHtcbiAgICAgICAgLi4uZGF0YSxcbiAgICAgICAgJ0BjbGFzcyc6IGRhdGFbJ0BjbGFzcyddID8gZGF0YVsnQGNsYXNzJ10gOiAnRmluZEFkcmVzeVBhcmFtc1ZPJyxcbiAgICB9O1xuXG5cbiAgICByZXR1cm4gcmVzdWx0O1xufVxuXG5leHBvcnQgZnVuY3Rpb24gdXBkYXRlTWFwRmluZEFkcmVzeVBhcmFtc182QjZBQUEoZGF0YSkge1xuICAgIGlmIChkYXRhID09IG51bGwpIHtcbiAgICAgICAgcmV0dXJuIGRhdGE7XG4gICAgfVxuICAgIGNvbnN0IHJlc3VsdCA9IHt9O1xuICAgIE9iamVjdC5rZXlzKGRhdGEpLmZvckVhY2goa2V5ID0+IHtcbiAgICAgICAgcmVzdWx0W2tleV0gPSB1cGRhdGVGaW5kQWRyZXN5UGFyYW1zXzZCNkFBQShkYXRhW2tleV0pO1xuICAgIH0pO1xuICAgIHJldHVybiByZXN1bHQ7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiB1cGRhdGVMaXN0RmluZEFkcmVzeVBhcmFtc182QjZBQUEoZGF0YSkge1xuICAgIGlmIChkYXRhID09IG51bGwpIHtcbiAgICAgICAgcmV0dXJuIGRhdGE7XG4gICAgfVxuICAgIHJldHVybiBkYXRhLm1hcCh1cGRhdGVGaW5kQWRyZXN5UGFyYW1zXzZCNkFBQSk7XG59XG4iXX0=